const communicator = {
  login: {
    subtitle: 'Connect your chat identity to your Prodgy account',
    missingToken: 'Invalid or missing authentication token. Please use /prodgy login in your chat to generate a new link.',
    authRequired: 'Authentication Required',
    authRequiredDescription: 'You need to log in to your Prodgy account to complete the link. Click the button below to sign in.',
    goToLogin: 'Sign in to Prodgy',
    confirming: 'Linking your account...',
    confirmFailed: 'Failed to link your account. The token may have expired. Use /prodgy login to generate a new link.',
    success: 'Account Linked!',
    successDescription: 'Your chat identity has been connected to your Prodgy account. You can now use /prodgy link <slug> to select a workspace.',
    canCloseTab: 'You can close this tab and return to your chat.',
    errorTitle: 'Link Failed',
    goHome: 'Go to Prodgy',
  },
};

export default communicator;
